import { Component, OnInit } from '@angular/core';
import { SpinnerServiceService } from 'src/app/modules/shared/serviceSpinner/spinner-service.service';
import { config } from 'src/app/config/api.config';
import { environment } from 'src/environments/environments';

@Component({
  selector: 'app-usernot-found',
  templateUrl: './usernot-found.component.html',
  styleUrls: ['./usernot-found.component.css'],
})
export class UserNotFoundComponent implements OnInit {
  showSpinner: boolean = false;

  constructor(private spinnerService: SpinnerServiceService) {
    this.spinnerService.spinner$.subscribe((data: boolean) => {
      setTimeout(() => {
        this.showSpinner = data ? data : false;
      });
    });
  }

  ngOnInit(): void {
    this.spinnerService.hideSpinner();
  }

  onClick() {
    sessionStorage.clear();

    window.location.href =
      'https://raagnale.force-n.sn/realms/' +
      environment.keycloak.realm +
      '/protocol/openid-connect/logout?client_id=' +
      environment.keycloak.clientId +
      '&post_logout_redirect_uri=' +
      config.redirectURI;
  }
}
